// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SupplierSelect from "../Supplier/SupplierSelect.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as TableLayoutPanel from "../../resources/layout-and-structure/TableLayoutPanel.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";
import * as InputOptionalNumberField from "../../resources/selection-and-input/InputOptionalNumberField.res.js";

function keyExtractor(row) {
  return row.supplierId + "-retail";
}

let Row = {
  keyExtractor: keyExtractor
};

function tableColumns(shopId, bulkUnit, onRequestSupplierUpdate, onRequestPurchasePriceUpdate) {
  return [
    {
      key: "supplier-id",
      name: I18n.t("Supplier"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 350
        }
      },
      render: param => {
        if (shopId !== undefined) {
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SupplierSelect.make, {
              preset: {
                NAME: "inputField",
                VAL: {
                  required: false
                }
              },
              shopId: shopId,
              value: {
                id: param.data.supplierId,
                name: ""
              },
              onChange: onRequestSupplierUpdate
            }),
            style: {
              width: "100%"
            }
          });
        } else {
          return null;
        }
      }
    },
    {
      key: "purchasedprice",
      name: I18n.t("Purchase price") + " " + I18n.t("HT"),
      render: param => JsxRuntime.jsx(InputOptionalNumberField.make, {
        value: param.data.purchasePrice,
        minValue: 0,
        precision: 3,
        placeholder: "0,000",
        appender: {
          TAG: "Custom",
          _0: I18n.toCurrencySymbol("EUR") + Stdlib_Option.mapOr(bulkUnit, "", unit => ` / ` + unit)
        },
        onChange: onRequestPurchasePriceUpdate
      })
    }
  ];
}

function CatalogVariantEditFormPurchasePriceTablePanel(props) {
  let match = CatalogVariantEditForm.useFormState().values;
  let bulk = match.bulk;
  let capacityUnit = match.capacityUnit;
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let shopId = Stdlib_Option.map(Auth.useActiveShop(), shop => shop.id);
  let onRequestSupplierUpdate = React.useCallback(supplier => {
    let supplierId = Stdlib_Option.flatMap(supplier, supplier => Primitive_option.fromNullable(supplier.id));
    if (supplierId !== undefined) {
      return dispatch({
        TAG: "FieldValueChanged",
        _0: "SupplierId",
        _1: param => supplierId
      });
    }
  }, []);
  let onRequestPurchasePriceUpdate = React.useCallback(purchasePrice => dispatch({
    TAG: "FieldValueChanged",
    _0: "PurchasePrice",
    _1: param => purchasePrice
  }), []);
  let columns = React.useMemo(() => tableColumns(shopId, capacityUnit !== undefined && bulk ? capacityUnit : undefined, onRequestSupplierUpdate, onRequestPurchasePriceUpdate), [
    capacityUnit,
    bulk,
    shopId
  ]);
  let rows = [{
      supplierId: match.supplierId,
      purchasePrice: match.purchasePrice
    }];
  let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable",
    customText: I18n.t("No purchase price has been yet recorded")
  });
  let data = {
    TAG: "Done",
    _0: {
      TAG: "Ok",
      _0: rows
    }
  };
  return JsxRuntime.jsx(TableLayoutPanel.make, {
    title: I18n.t("Purchase price"),
    description: I18n.t("Enter the product purchase price."),
    children: JsxRuntime.jsx(TableView.make, {
      data: data,
      columns: columns,
      keyExtractor: keyExtractor,
      placeholderEmptyState: placeholderEmptyState
    })
  });
}

let make = React.memo(CatalogVariantEditFormPurchasePriceTablePanel);

export {
  Row,
  tableColumns,
  make,
}
/* make Not a pure module */
